import { render, staticRenderFns } from "./egym-workouts-list.component.vue?vue&type=template&id=364566ce"
import script from "./egym-workouts-list.component.ts?vue&type=script&lang=ts&external"
export * from "./egym-workouts-list.component.ts?vue&type=script&lang=ts&external"
import style0 from "./egym-workouts-list.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports